export default __webpack_public_path__ + "static/media/figma.7598e83e.svg";